export const documentationState: aboTheme.IState = {
    parent: "app",
    name: "documentation",
    url: "/documentation",
    component: "documentationComponent",
    data: {
        permissions: {
            only: ['BACKOFFICE', 'EMPLOYEE'],
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/documentation/documentation.states.ts